import { create } from 'zustand';

export type SettingsTabKey = 'page-settings' | 'domain-settings' | 'subscription-settings' | 'danger-zone';

type SettingsDialogStore = {
  isOpen: boolean;
  selectedTabKey: SettingsTabKey;
  open: (tabKey?: SettingsTabKey) => void;
  close: () => void;
  setTab: (tabKey: SettingsTabKey) => void;
};

export const useSettingsDialogStore = create<SettingsDialogStore>((set) => ({
  isOpen: false,
  selectedTabKey: 'page-settings',
  open: (tabKey) =>
    set((state) => ({
      isOpen: true,
      selectedTabKey: tabKey ?? state.selectedTabKey,
    })),
  close: () => set({ isOpen: false }),
  setTab: (tabKey) => set({ selectedTabKey: tabKey }),
}));
